<template>
  <d-container fluid class="main-content-container p-0">
    <h6>Comentários</h6>
    <d-form @submit="submit">
      <d-form-row>
        <d-col>
          <textarea class="form-control" v-model="comment" placeholder="O que você tem a dizer sobre a loja?"></textarea>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col class="mt-3 d-flex justify-content-end">
          <d-button theme="primary" type="submit">Comentar</d-button>
        </d-col>
      </d-form-row>
    </d-form>
    <ul class="comment-list">
      <li v-for="(comment, index) in list" :key="comment.id">
        <small>
          <strong>{{ comment.user.name }}</strong> - {{ comment.user.settings.type.name }}
          <span class="text-muted font-italic" v-if="comment.created_at !== comment.updated_at">(Editado)</span>
          <a v-if="user.id === comment.user.id" class="link" @click="toggleComment(index)">
            {{ editComment === index ? 'Cancelar' : 'Editar'}}
          </a>

        </small>
        <p v-if="editComment !== index" :class="{'admin-comment': comment.user.settings.type.slug === 'admin'}">{{comment.comment}}</p>
        <div v-else>
          <textarea class="form-control" rows="5" v-model="comment.comment"></textarea>
          <div class="d-flex justify-content-end mt-3">
            <d-button size="sm" theme="primary" type="button" @click="updateComment(comment)">Atualizar</d-button>
          </div>
        </div>
      </li>
    </ul>
  </d-container>
</template>

<script>
import ResellerService from '_services/rest/modules/reseller';

export default {
  name: 'Reseller-comments',
  props: {},
  data() {
    return {
      comment: null,
      editComment: null,
      list: [],
      resellerId: this.$route.params.resellerId,
    };
  },
  computed: {
    user() {
      const { user } = this.$store.state.user;
      return user;
    },
  },
  methods: {
    getComments() {
      ResellerService.getCommentList(this.resellerId)
        .then(response => {
          this.list = response.list;
        });
    },
    toggleComment(index) {
      if (this.editComment === index) {
        this.editComment = null;
        return false;
      }
      this.editComment = index;
      return true;
    },
    submit(event) {
      event.preventDefault();
      ResellerService.saveComment({ id: this.resellerId, comment: this.comment })
        .then(() => {
          this.comment = null;
          this.getComments();
        });
    },
    updateComment(comment) {
      ResellerService.updateComment({ id: this.resellerId, comment })
        .then(response => {
          comment = response;
          this.editComment = null;
        });
    },
  },
  mounted() {
    this.getComments();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.comment-list {
  list-style: none;
  padding-left: 0px;
  li {
    margin-bottom: 5px;
    .link {
      cursor: pointer;
      color: $cyan;
    }
    p {
      padding: 10px;
      border: 1px solid $border-color;
      border-radius: 5px;
      background: #f5f6f7;
    }
    .admin-comment {
      background: #ddeef9;
    }
  }
}
</style>
